import { render } from "./ProductGeneralComponent.vue?vue&type=template&id=23d5990c"
import script from "./ProductGeneralComponent.vue?vue&type=script&lang=js"
export * from "./ProductGeneralComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__